module.exports = __webpack_public_path__ + "media/images/athletes/528-871d7224eef01f117649ce5110929bf0.png";